module.exports = __webpack_public_path__ + "img/no_results.7fb91fb1.png";